import { Form } from "formik";

export default function FullWidthForm({ children, ...props }) {
  return (
    <Form
      {...props}
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        width: "100%",
        minWidth: "400px",
      }}
    >
      {children}
    </Form>
  );
}
